export default "/images/frontPageBackgroundImage.png?ef255a608c65dcc7279a4bbd8a2a0636";